export default __webpack_public_path__ + "static/media/SmartCity.4ea44e1a.pdf";